import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';
import { Notice } from '@wodi/ui';

import { offersSentence, roleOffersQuery } from '../api/roles.ts';
import { can, sessionQuery } from '../api/session.ts';

/**
 * "New permissions are available for 3 roles", with a link to review them, for people who
 * manage roles. Shows nothing while loading, on error or when there is nothing to review:
 * the Role updates page itself shows those states.
 */
export function RoleUpdatesNotice() {
  const { data: session } = useSuspenseQuery(sessionQuery);
  const allowed = session !== null && can(session, 'admin.roles.manage');
  const offers = useQuery({ ...roleOffersQuery, enabled: allowed });
  const count = offers.data?.roles.length ?? 0;
  if (!allowed || count === 0) return null;
  return (
    <Notice tone="info" action={<Link to="/settings/role-updates">Review role updates</Link>}>
      {offersSentence(count)}
    </Notice>
  );
}
